import { render, staticRenderFns } from "./AddMoreDetails.vue?vue&type=template&id=9f3403b4&scoped=true"
import script from "./AddMoreDetails.vue?vue&type=script&lang=js"
export * from "./AddMoreDetails.vue?vue&type=script&lang=js"
import style0 from "./AddMoreDetails.vue?vue&type=style&index=0&id=9f3403b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3403b4",
  null
  
)

export default component.exports